import React, { useEffect, useState } from "react";
import HealthSummaryData from "./HealthSummaryData";
import HealthScreenLog from "./HealthScreenLog";
// import EventList from './EventList';
import "./HealthScreenDetail.css"; // Assuming you have a CSS file for styles
import moment from "moment";
import { HealthScreenChart } from "./HealthScreenChart";
import { Col, Empty, Row, Segmented, Tabs } from "antd";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../../global/ProLanguageContext";

const HealthScreenDetail = ({ screen, data }) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).analytics;
  const [activeTab, setActiveTab] = useState("day");
  const [screenData, setScreenData] = useState(data);

  // Calculate summary stats
  const totalUptime = 0; // !screen.healthData ? 0 : screen.healthData.reduce((acc, day) => acc + day.uptime, 0) / screen.healthData.length;
  const totalDowntime = 0; //!screen.healthData ? 0 : screen.healthData.reduce((acc, day) => acc + day.downtime, 0) / screen.healthData.length;
  const lastDowntime = "No downtime recorded";

  // Summary data for the summary cards
  const summaryData = [
    { label: "Avg. Uptime", value: `${totalUptime.toFixed(1)}%` },
    { label: "Avg. Downtime", value: `${totalDowntime.toFixed(1)}%` },
    {
      label: "Last Downtime",
      value:
        typeof lastDowntime === "string"
          ? lastDowntime
          : new Date(lastDowntime).toLocaleString(),
    },
    { label: "Total Events", value: 0 },
  ];

  useEffect(() => {
    if (data) {
      setScreenData(data);
    }
  }, [data]);

  return (
    <div className="screen-detail-scroll-container" style={{}}>
      {screen && screenData && screenData.DataScreen ? (
        <>
          <div
            className="card-header"
            style={{
              padding: "16px 20px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "start",
              }}
            >
              <h2 className="card-title" style={{ fontSize: "16px" }}>
                {screen.ScreenName}
              </h2>
              <p className="card-subtitle">{`${screen.BranchName}  ·  ${t.detailOpen} ${moment(screenData.DataScreen.OpenTime, "HH:mm:ss").format("LT")} – ${moment(screenData.DataScreen.CloseTime, "HH:mm:ss").format("LT")}`}</p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                gap: 4,
              }}
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "4px 12px",
                  borderRadius: 20,
                  fontSize: 12,
                  fontWeight: 600,
                  background: screenData.DataScreen.is_online
                    ? "#f0fdf4"
                    : "#fef2f2",
                  color: screenData.DataScreen.is_online
                    ? "#16a34a"
                    : "#dc2626",
                  border: `1px solid ${screenData.DataScreen.is_online ? "#bbf7d0" : "#fecaca"}`,
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: screenData.DataScreen.is_online
                      ? "#16a34a"
                      : "#dc2626",
                    flexShrink: 0,
                  }}
                />
                {screenData.DataScreen.is_online
                  ? t.detailOnline
                  : t.detailOffline}
                {!screenData.DataScreen.is_online &&
                  screenData.DataScreen.LastOnline && (
                    <span
                      style={{
                        fontWeight: 400,
                        color: "#94a3b8",
                        marginLeft: 4,
                      }}
                    >
                      · {t.detailLastSeen}{" "}
                      {moment(
                        screenData.DataScreen.LastOnline,
                        "YYYY/MM/DD HH:mm:ss",
                      ).format("MMM D, h:mm A")}
                    </span>
                  )}
              </span>
              <p className="card-subtitle">
                {`${t.detailUpdated} ${moment(screenData.DataScreen.last_resource_update, "YYYY/MM/DD HH:mm:ss").format("MMM D, YYYY [at] h:mm A")}`}
              </p>
            </div>
          </div>
          <Row style={{ width: "100%" }}>
            <Col
              span={24}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "1rem",
              }}
            >
              {screenData ? (
                <HealthSummaryData data={screenData.DataScreen} />
              ) : null}
            </Col>
            <Col span={24}>
              <div style={{ flexGrow: 1, padding: "1rem" }}>
                <Tabs
                  defaultActiveKey="week"
                  items={[
                    {
                      key: "day",
                      label: t.tabToday,
                      children: (
                        <HealthScreenChart data={screenData} mode="day" />
                      ),
                    },
                    {
                      key: "week",
                      label: t.tab7Days,
                      children: (
                        <HealthScreenChart data={screenData} mode="week" />
                      ),
                    },
                    {
                      key: "month",
                      label: t.tab30Days,
                      children: (
                        <HealthScreenChart data={screenData} mode="month" />
                      ),
                    },
                  ]}
                  onChange={(key) => setActiveTab(key)}
                />

                {/* <Segmented value={activeTab} options={['Today', 'Last 7 Days', 'Last 30 Days']} defaultValue={activeTab} onChange={(value) => setActiveTab(value)}>
                            
                        </Segmented>
                        <HealthScreenChart></HealthScreenChart> */}
              </div>
            </Col>
            <Col span={0}>
              <div style={{ flexGrow: 1 }}>
                {/* <HealthScreenChart></HealthScreenChart> */}
              </div>
            </Col>
          </Row>
          <HealthScreenLog
            screenData={screenData.DataScreen}
            screenLogData={screenData.RawData.sort((a, b) =>
              moment(b.OnlineTime).diff(moment(a.OnlineTime)),
            )}
          />
        </>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            padding: "60px 20px",
          }}
        >
          <Empty
            description={
              <span style={{ color: "#94a3b8", fontSize: 14 }}>
                {t.emptySelectScreen || "Select a screen to view details"}
              </span>
            }
          />
        </div>
      )}
    </div>
  );
};

export default HealthScreenDetail;
